export default __webpack_public_path__ + "static/media/background-maze.4d0bb255.png";